import { AxiosResponse } from 'axios';
import logo from 'img/logo.png';
import { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CtxAuth } from 'views/utils/Contexts';
import { getRef } from 'views/utils/InputHelp';
import * as MessageBox from "../../../common/MessageBox";

export function Login(): JSX.Element{

    const cua = useContext(CtxAuth);
    const history = useHistory();
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const username = useRef<HTMLInputElement>(null);
    const password = useRef<HTMLInputElement>(null);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    
    const keyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if(event.key === 'Enter'){
            event.preventDefault()
            clickSubmit()
        }
    }

    function clickSubmit(){
        setSubmitDisabled(true);
        cua.login(getRef(username), getRef(password), 
            function(res:AxiosResponse<any>){
                if( res.status === 200 ){
                    //正常ケース
                    history.push('/admin/order/list');
                } else {
                    if( res.status === 400 || res.status === 401 ){
                        setMsgArgs({type:MessageBox.MSGBOX_TYPE_ERROR, text:"ユーザー名またはパスワードが正しくありません"});
                    } else {
                        setMsgArgs({type:MessageBox.MSGBOX_TYPE_ERROR, text:"ログインに失敗しました"});
                    }
                }
                setSubmitDisabled(false);
            }
        );
    }

    return (
        <div className="contents">
            <MessageBox.MessageBox args={msgArgs}/>
            <h1 className="login-system-title"><img src={logo} alt="mitsumol"/></h1>
            <div className="login-box">
                <div className="form-row"><input type="text" className="login-input" placeholder="ユーザー名" ref={username}/></div>
                <div className="form-row"><input type="password" className="login-input" placeholder="パスワード" ref={password} onKeyPress={keyPress}/></div>
                <div className="form-row"><button className="btn-primary btn-login" onClick={clickSubmit} disabled={submitDisabled}>ログイン</button></div>
            </div>
        </div>
    )
}